import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { MdImageNotSupported } from 'react-icons/md';
import { FaUser } from 'react-icons/fa';
import styles from './FallbackImage.module.css';

const FallbackImage = ({ className, src, alt, type = "image" }) => {
  const [imageError, setImageError] = useState(false);

  if (!src || imageError) {
    if (type === "user") {
      return (
        <Box className={`${styles.fallbackPicIcon} ${className}`}>
          <FaUser className={styles.picFallbackIcon} />
        </Box>
      );
    }

    if (type === "image") {
    return (
        <Box className={`${styles.fallbackImageBox} ${className}`}>
          <MdImageNotSupported className={styles.fallbackIcon} />
          <Typography className={styles.fallbackText}>No Image</Typography>
        </Box>
      );
    }

    return (
      <Box className={`${styles.fallbackImageBox} ${className}`}>
        <Typography className={styles.fallbackText}>No Image</Typography>
      </Box>
    );
  }

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      onError={() => setImageError(true)}
    />
  );
};

FallbackImage.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  type: PropTypes.oneOf(['default', 'image', 'user']),
};

export default FallbackImage;